import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, CircularProgress, Button } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, isLoading } = useAuth();
  const [showLoginButton, setShowLoginButton] = useState(false);
  const search = new URLSearchParams(location.search);
  const requestedReturnUrl = search.get('returnUrl') || '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    if (!isLoading && !isAuthenticated && !showLoginButton) {
      const timer = setTimeout(() => {
        login(requestedReturnUrl)
          .then(() => {})
          .catch(() => setShowLoginButton(true));
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, isLoading, login, navigate, showLoginButton, requestedReturnUrl]);

  const handleLoginClick = async () => {
    try {
      await login(requestedReturnUrl);
    } catch (error) {
      console.error('Failed to redirect to Keycloak:', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {showLoginButton ? (
          <>
            <Typography variant="h4" component="h1" gutterBottom>
              Optima Travel
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Sign in to continue
            </Typography>
            <Button variant="contained" size="large" onClick={handleLoginClick} sx={{ mt: 2 }}>
              Login with SSO
            </Button>
          </>
        ) : (
          <>
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" color="text.secondary">
              Redirecting to login...
            </Typography>
          </>
        )}
      </Box>
    </Container>
  );
};

export default LoginPage;
